export default __webpack_public_path__ + "static/media/left.51e44b80.png";